import { Card } from "@/components/ui/card";
import { DragHandle } from "@/components/ui/drag-handle";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SwappableCardProps {
  id: string;
  children: React.ReactNode;
  className?: string;
  showHandle?: boolean;
  onRemove?: (id: string) => void;
}

export function SwappableCard({ 
  id,
  children, 
  className, 
  showHandle, 
  onRemove 
}: SwappableCardProps) {
  return (
    <Card className={`relative ${className}`}>
      {showHandle && (
        <div className="absolute top-2 left-2 z-10">
          <DragHandle />
        </div>
      )}
      
      {onRemove && (
        <Button 
          variant="ghost" 
          size="icon" 
          className="absolute top-2 right-2 z-10 rounded-full h-6 w-6 bg-muted/60 backdrop-blur-sm"
          onClick={() => onRemove(id)}
        >
          <X className="h-3 w-3" />
          <span className="sr-only">Remove widget</span>
        </Button>
      )}
      
      {children}
    </Card>
  );
}
